import React from 'react';

const SmsTrackingLogFormModal = React.lazy(() => import('../components/FormModal'));
const smsTrackingLogModalRegistry = {
    notification_smsTrackingLogId: SmsTrackingLogFormModal
};
export default smsTrackingLogModalRegistry;
